import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('PaymentFaqLinkWrapper')(() => css({
    display: 'flex',
    justifyContent: 'flex-end',
    mt: 'm',
}));
themeStyles.addBaseStyles('ComparePaymentLink')(() => css({
    display: 'flex',
    alignItems: 'center',
}));
export default themeStyles;
